export enum TokenVaultFilterKey {
  Action = 'action',
  Status = 'status',
  Verification = 'verification',
}

export const TOKEN_VAULT_FILTER_KEYS = [
  TokenVaultFilterKey.Action,
  TokenVaultFilterKey.Status,
  TokenVaultFilterKey.Verification,
];
